export default "__VITE_ASSET__BDdWEaML__"